import { defaultDictionaryValueMissing } from '../repository';

export type PreviewKey = 'ExitPreview' | 'InPreview';

export const getDefaultPreviewValue = (key: PreviewKey): string => {
	switch (key) {
		case 'ExitPreview':
			return 'Afslut forhåndsvisning';
		case 'InPreview':
			return 'Du er i øjeblikket i forhåndsvisningstilstand';
		default:
			return `${defaultDictionaryValueMissing}:${key}`;
	}
};
